import InterMediumItalicText from './InterMediumItalicText';

export default InterMediumItalicText;
